import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi, type TransferRequestUpdateStatusRequest, type TransferRequestResponse } from '@shared/api';
import { Constants } from '@shared/constants';

const updateStatusEffect = createEffect((request: TransferRequestUpdateStatusRequest) => TransferRequestsApi.updateStatus(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestResponse | null>(null)
  .on(updateStatusEffect.done, (_, values) => values.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateStatusEffect.pending, (_, data) => data)
  .on(updateStatusEffect.fail, () => false)
  .on(updateStatusEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: string | null } | null>(null)
  // .on(updateStatusEffect, () => null)
  .on(updateStatusEffect.fail, (_, data) => {
    if (data.error.message === 'Invalid code, try again') return null;
    const error = ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating Status. Please try again.');
    return Constants.VOP_ERROR_CODES.includes(error.errorCode || '') ? error : { message: error.message };
  })
  .on(updateStatusEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $transferUpdateStatusStore = {
  events: {
    updateStatus: updateStatusEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
